import IdbHandler from '../idb/idbHandler';

const $ = jQuery.noConflict();

'use strict';

const SearchCompanies = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	/** @description Initialize */
	init: function() {
		this.bindEvents();
		this.populateCompaniesDropdown();
		this.triggerSearch();
	},

	/** @description Bind events */
	bindEvents: function() {
		const $notFoundCheckbox = $('#company-not-found-checkbox');
		const $newCompanyInput = $('#new-company-input');
		const $companyDropdown = $('#reg-field-name-comp');

		$notFoundCheckbox.on('change', function() {
			if (this.checked) {
				$newCompanyInput.show().prop('required', true);
				$companyDropdown.val('').prop('disabled', true);
			} else {
				$newCompanyInput.hide().prop('required', false);
				$companyDropdown.prop('disabled', false);
			}
		});
	},

	/** @description Normalize text by removing diacritical marks */
	normalizeText: function(text) {
		return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
	},

	/** @description Populate the dropdown with companies from IndexedDB */
	populateCompaniesDropdown: function() {
		const $companyDropdown = $('#reg-field-name-comp');

		IdbHandler.openDatabase().then((db) => {
			const transaction = db.transaction('companies', 'readonly');
			const store = transaction.objectStore('companies');
			const companies = [];

			store.openCursor().onsuccess = function(event) {
				const cursor = event.target.result;

				if (cursor) {
					companies.push(cursor.value);
					cursor.continue();
				} else {
					// Populate dropdown with companies
					$companyDropdown.empty().append('<option value="">Select a company</option>'); // Default option
					companies.forEach((company) => {
						$companyDropdown.append(
							`<option value="${company.ID}">${company.title}</option>`
						);
					});
				}
			};

			transaction.onerror = function(event) {
				console.error('Error populating dropdown: ', event.target.error);
			};
		});
	},

	/** @description Search for companies in IndexedDB */
	searchCompaniesInIndexedDB: function(query) {
		return new Promise((resolve, reject) => {
			IdbHandler.openDatabase().then((db) => {
				const transaction = db.transaction('companies', 'readonly');
				const store = transaction.objectStore('companies');
				const companies = [];
				let totalCount = 0;
				let resultCount = 0;

				const normalizedQuery = this.normalizeText(query);

				store.openCursor().onsuccess = function(event) {
					const cursor = event.target.result;

					if (cursor) {
						const company = cursor.value;
						const normalizedTitle = SearchCompanies.normalizeText(company.title || '');

						if (normalizedTitle.includes(normalizedQuery)) {
							totalCount++;

							// Return the first 10 companies
							if (resultCount < 10) {
								companies.push(company);
								resultCount++;
							}
						}
						cursor.continue();
					} else {
						// Return first 10 results and total count
						resolve({companies, totalCount});
					}
				};

				transaction.onerror = function(event) {
					reject('Error searching companies in IndexedDB: ' + event.target.errorCode);
				};
			});
		});
	},

	/** @description Function to trigger search */
	triggerSearch: function() {
		const inputs = document.querySelectorAll('.js-companies-search');

		if (inputs.length < 1) {
			return false;
		}

		let timer; // Timer identifier
		const waitTime = 250; // Wait time in milliseconds

		const handleInput = (e) => {
			clearTimeout(timer);
			const ele = e.currentTarget;

			const value = ele.value.trim();
			if (value === '') {
				$('.js-companies-search-display-box').removeClass('is-visible');
				return;
			}
			if (value.length < 1) {
				return false;
			}

			timer = setTimeout(() => {
				$('.js-search-loader').addClass('is-visible');

				this.searchCompaniesInIndexedDB(value).then((result) => {
					const {companies, totalCount} = result;

					if (companies.length > 0) {
						let resultHTML = companies
							.map(
								(company) => `
						<a class="search-company-link" href="${window.origin}/company/${company.slug}">
							<div class="search-company-image">
								<img src="${
									company.logo
										? company.logo
										: window.origin +
										'/wp-content/themes/office-pulse-theme/src/assets/images/no-image.jpg'
								}" alt="Product Image">
							</div>
							<span>${company.title}</span>
						</a>
					`
							)
							.join('');
						resultHTML += `
						<div class="search-total-count">
							<a href="${window.location.origin}?s=${value}">Pogledaj sve rezultate
							(${totalCount})</a>
						</div>
					`;
						$(ele)
							.parent()
							.find('.js-companies-search-display-box')
							.html(resultHTML)
							.addClass('is-visible');
					} else {
						$(ele)
							.parent()
							.find('.js-companies-search-display-box')
							.html('<p>Nema rezultata.</p>')
							.addClass('is-visible');
					}
				}).catch((error) => {
					console.error('Search error: ', error);
				});
			}, waitTime);
		};

		inputs.forEach((input) => {
			input.addEventListener('input', handleInput.bind(this));
			input.addEventListener('keydown', (event) => {
				if (event.key === 'Enter') {
					event.preventDefault();
					window.location.href = window.origin + '?s=' + input.value;
					document.body.classList.add('loader-visible');
				}
			});
		});
	},
};

export default SearchCompanies;
